// FIXME: This should be exported from the ra-core package
type CanAccessParams<
  RecordType extends Record<string, any> = Record<string, any>,
> = {
  action: string;
  resource: string;
  record?: RecordType;
};

// «Avtaler» (oversikten over løpende avtaler) er bare for administrator.
const ADMIN_ONLY_RESOURCES = ["costs", "agreements"];

export const canAccess = <
  RecordType extends Record<string, any> = Record<string, any>,
>(
  role: string,
  params: CanAccessParams<RecordType>,
) => {
  if (role === "admin") {
    return true;
  }

  // Non admins can't access the sales resource
  if (params.resource === "sales") {
    return false;
  }

  // Non admins can't access the configuration resource
  if (params.resource === "configuration") {
    return false;
  }

  // Mimin 1.5 (US08): satser/kost/margin er bare for administrator, og bare administrator sletter eller slår sammen kunder og
  // kontakter. Databasen håndhever det samme; dette styrer bare hva som vises.
  if (ADMIN_ONLY_RESOURCES.includes(params.resource)) {
    return false;
  }
  // Pipeline pakke 6 (kap. 15): alle ser Rapporter med Salg-fanen
  // (list og sales). De andre fanene (action "admin": Nøkkeltall, Timer,
  // Kunder, Fakturagrunnlag og lønnsomhet) er bare for administrator.
  if (params.resource === "reports") {
    return params.action === "list" || params.action === "sales";
  }
  if (
    (params.resource === "companies" || params.resource === "contacts") &&
    (params.action === "delete" || params.action === "merge")
  ) {
    return false;
  }
  // Pipeline pakke 7 (AK43): medarbeidere kan arkivere muligheter, men bare
  // administrator sletter dem. RLS i databasen håndhever det samme.
  if (params.resource === "deals" && params.action === "delete") {
    return false;
  }

  return true;
};
